<template>
  <b-form-group
    v-if="!dataLoad"
    label="Priority"
  >
    <b-form-select
      v-model="priority"
      :options="priorityOptions"
      trim
      @change="$emit('handlePriority', priority)"
    />

  </b-form-group>
</template>

<script>

export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      priority: this.$route.query.priority || '',
      priorityOptions: [
        { value: 'high', text: 'High' },
        { value: 'medium', text: 'Medium' },
        { value: 'low', text: 'Low' },
      ],
    }
  },
}
</script>
